import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { PasswordInput } from "./PasswordInput";

const selectCls = "flex h-10 w-full rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring";

const Field = ({ f, value, onChange, options, testid }) => {
  if (f.type === "textarea")
    return <Textarea id={f.name} value={value ?? ""} onChange={(e) => onChange(e.target.value)} required={f.required} rows={3} data-testid={testid} />;
  if (f.type === "select")
    return (
      <select id={f.name} value={value ?? ""} onChange={(e) => onChange(e.target.value)} required={f.required} className={selectCls} data-testid={testid}>
        <option value="">- Pilih -</option>
        {(f.options || options || []).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    );
  if (f.type === "password")
    return <PasswordInput id={f.name} value={value ?? ""} onChange={(e) => onChange(e.target.value)} required={f.required} placeholder={f.placeholder} minLength={f.minLength} autoComplete="new-password" data-testid={testid} />;
  return (
    <Input id={f.name} type={f.type || "text"} step={f.type === "number" ? "any" : undefined} value={value ?? ""}
      onChange={(e) => onChange(e.target.value)} required={f.required} placeholder={f.placeholder}
      minLength={f.minLength} data-testid={testid} />
  );
};

export const FormFields = ({ fields, form, setForm, optionsMap = {}, prefix }) => (
  <div className="space-y-4">
    {fields.filter((f) => f.type !== "hidden" && (!f.showIf || f.showIf(form))).map((f) => (
      <div key={f.name} className="space-y-1.5">
        <Label htmlFor={f.name}>{f.label}{f.required && <span className="text-red-600"> *</span>}</Label>
        <Field f={f} value={form[f.name]} options={optionsMap[f.name]} testid={`${prefix}-field-${f.name}`}
          onChange={(v) => setForm((s) => ({ ...s, [f.name]: v }))} />
        {f.help && <p className="text-xs text-slate-500">{f.help}</p>}
      </div>
    ))}
  </div>
);

export const buildPayload = (fields, form) => {
  const out = {};
  fields.forEach((f) => {
    if (f.showIf && !f.showIf(form)) return;
    let v = form[f.name];
    if (f.type === "number") v = v === "" || v == null ? null : Number(v);
    else if (v === "" && !f.required) v = f.type === "select" || f.type === "date" ? null : "";
    if (v === undefined) return;
    out[f.name] = v;
  });
  return out;
};
